const displayAccountName = (displayName: string, originalName: string) => {
  let formattedName = displayName;
  if (displayName?.trim() !== originalName?.trim()) {
    formattedName = `${displayName} (${originalName})`;
  }
  return formattedName ?? 'N/A';
};

export default displayAccountName;
